import { render, staticRenderFns } from "./rehbersoforara.vue?vue&type=template&id=0b5e13b8"
import script from "./rehbersoforara.vue?vue&type=script&lang=js"
export * from "./rehbersoforara.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports